module.exports = __webpack_public_path__ + "static/media/android-chrome-192x192.9c7c9582.png";